import * as React from "react";
import { Link } from "react-router-dom";
import { ITranslationProps, translateComponent } from "../../helpers/translation";
import IClientSearchResult from "../../types/IClientSearchResult";

interface IClientRowProps extends ITranslationProps, IClientSearchResult {
    canLoginAsClient: boolean;
}

class ClientRow extends React.Component<IClientRowProps> {
    constructor(props: IClientRowProps) {
        super(props);
    }

    public render() {
        return (
            <tr>
                <td><Link to={`/client/${this.props.id}`} title={`Open ${this.props.clientName}`}>{this.props.clientName}</Link></td>
                <td>{this.props.isActive ? this.props.t("Global.Active") : this.props.t("Global.Inactive")}</td>
                {
                    this.props.canLoginAsClient &&
                    <td><Link to={`/loginToClient/${this.props.id}`} title={`Login to ${this.props.clientName}`}>{this.props.t("ClientList.LoginLink")}</Link></td>
                }
            </tr>
        );
    }
}

export default translateComponent(ClientRow);



// WEBPACK FOOTER //
// ./src/components/ClientList/ClientRow.tsx